"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
/* eslint-disable react/jsx-indent */

var ButtonStyled = (0, _styledComponents["default"])(_buttons.Button).attrs({
  className: 'fuse-pagination__page-button',
  'data-testid': 'fuse-pagination__page-button'
}).withConfig({
  displayName: "styled-button__ButtonStyled",
  componentId: "sc-1xomt4v-0"
})(["&{background-color:var(--color-global-grey200);margin-right:var(--spacing-global-space3);width:var(--spacing-global-space9);height:var(--spacing-global-space9);border:none;padding:0;font-weight:500;}&:active{color:var(--color-global-black);background-color:var(--color-global-grey200);box-shadow:none;}&:hover:enabled{background-color:var(--color-global-grey200);border:1px solid var(--color-global-grey500);box-shadow:none;}&:focus{outline:none;}&:focus-visible,&:focus-visible:enabled{outline:2px solid var(--color-functional-focus);outline-offset:var(--spacing-global-space1);background-color:var(--color-global-grey200);border:1px solid var(--color-global-grey500);box-shadow:none;}&:disabled,&.active-page:focus:enabled{color:var(--color-global-black);background-color:var(--color-global-grey200);border:1px solid var(--color-global-black);cursor:unset;}"]);
var _default = exports["default"] = ButtonStyled;